import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Alert from 'react-s-alert'

import TopLevelMetric from './TopLevelMetric'
import AudienceRecoComponent from './AudienceRecoComponent'
import Spinner from '../Spinner'
import Profile from '../../classes/profile'
import TopicHelpers from '../../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../../classes/TopicPlanFilterHelpers'
import { CURRENT_FILTER, FILTER_MODE_APPLY, FILTER_MODE_MENU, MEDIA_PREFERENCE, MEDIA_PREFERENCE_MODULE, TLM_FILTER } from '../../constants/commons'
import * as TLM from '../../constants/tlm'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { MediaPrefrenceActive } from '../../classes/FilterHelpers'
export default class AudienceMediaComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    location: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    tlmFilters: PropTypes.array.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      currentPage: PropTypes.number.isRequired,
      error: PropTypes.object,
      details: PropTypes.object,
      endOfResult: PropTypes.bool.isRequired
    }).isRequired,
    topLevelMetrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number,
    fetchTopicPlan: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(MEDIA_PREFERENCE_MODULE, this.props.location, this.props.profile)
    this.props.setFilters(MediaPrefrenceActive, CURRENT_FILTER, MEDIA_PREFERENCE, FILTER_MODE_MENU)
    setTimeout(() => {
      this.props.fetchTopicPlan(MEDIA_PREFERENCE, FILTER_MODE_MENU)
    }, 500)
  }

  componentDidUpdate (prevProps) {
    if (this.props.topicDetails.error && !prevProps.topicDetails.error) {
      Alert.error('Error fetching audience, please retry')
    }
    if (this.props.topicPlan.error && !prevProps.topicPlan.error) {
      Alert.error('Error fetching plan, please retry')
    }
    if (!this.props.filters.equals(prevProps.filters)) {
      console.log('new filters', this.props.filters.toString())
    }
    if (this.props.topicPlan !== prevProps.topicPlan) {
      console.log('new plan', this.props.topicPlan)
    }
  }

  render () {
    if (this.props.topicDetails.isFetching) {
      return (<Spinner />)
    }

    const tlmCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 7 : 6
    const recoCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 5 : 6
    return (
      <Row>
        <Container fluid={true} className="rightSideContainer audienceContainer">
          <Row>
            <Col xl={tlmCol} lg={tlmCol} md={12} sm={12} className="leftRow">
              <div className="borderBox getScreenHeight">
                <Row>
                  <MediaTopLevelMetrics
                    topLevelMetrics={this.props.topLevelMetrics}
                    isAdmin={this.props.isAdmin}
                    tlmFilters={this.props.tlmFilters}
                    setFilters={this.props.setFilters}
                    fetchTopicPlan={this.props.fetchTopicPlan}
                    />
                </Row>
              </div>
            </Col>
            <Col xl={recoCol} lg={recoCol} md={12} sm={12}>
              <AudienceRecoComponent
                topicPlan={this.props.topicPlan}
                loadMore={this.props.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                location={this.props.location}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                screenWidth={this.props.screenWidth}
                fetchTopicPlan={this.props.fetchTopicPlan}
                />
            </Col>
          </Row>
        </Container>
      </Row>
    )
  }
}
export class MediaTopLevelMetrics extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    tlmFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    topLevelMetrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    fetchTopicPlan: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      streamingSelectedPage: TLM.TLM_FIRST_PAGE,
      channelSelectedPage: TLM.TLM_FIRST_PAGE,
      genreSelectedPage: TLM.TLM_FIRST_PAGE
    }
  }

  handlePagination = (dataType, page) => {
    switch (dataType) {
      case TLM.TLM_STREAMING:
        this.setState({ streamingSelectedPage: page })
        break
      case TLM.TLM_CHANNEL:
        this.setState({ channelSelectedPage: page })
        break
      case TLM.TLM_GENRE:
        this.setState({ genreSelectedPage: page })
        break
      default:
        break
    }
  }

  render () {
    if (!this.props.topLevelMetrics || !this.props.topLevelMetrics.details) {
      return null
    }

    const metrics = this.props.topLevelMetrics.details

    let selected = []
    let keys = TLM.TLM_KEYS.split(',')
    keys.forEach(key => {
      Object.keys(metrics[key]).forEach(metric => {
        let name = metrics[key][metric].name
        let filter = TopicPlanFilterHelpers.tlmFilter(name, key)
        if (this.props.tlmFilters && this.props.tlmFilters.find(f => TopicHelpers.equals(f, filter))) {
          selected.push(name)
        }
      })
    })

    const onClick = (menu, key) => {
      let filters = TopicPlanFilterHelpers.tlmFilter(menu, key)
      this.props.setFilters(filters, TLM_FILTER, MEDIA_PREFERENCE)
      setTimeout(() => {
        this.props.fetchTopicPlan(MEDIA_PREFERENCE, FILTER_MODE_APPLY)
      }, 500)
    }

    return (
      <Container id='tlmRow' fluid={true}>
        <Row>
          <Col xl={6} lg={6} md={12} className='minHeight100'>
            <TopLevelMetric
              title='Content Preference'
              color='188,33,49'
              negativeColor='253,157,169'
              gradientColor = 'gradient-red'
              data={metrics.vpp}
              dataType={TLM.TLM_VPP}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              />
          </Col>
          <Col xl={6} lg={6} md={12} className='minHeight100'>
            <TopLevelMetric
              title='Entity Type Preference'
              color='247,148,30'
              negativeColor='255,210,160'
              gradientColor = 'gradient-orange'
              data={metrics.entity}
              dataType={TLM.TLM_ENTITY}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              />
          </Col>
        </Row>
        <Row>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Streaming Preference'
              color='64,137,251'
              negativeColor='186,213,250'
              gradientColor = 'gradient-blue'
              data={metrics.streaming.sort((a, b) => b.value - a.value)}
              dataType={TLM.TLM_STREAMING}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              streamingSelectedPage={this.state.streamingSelectedPage}
              handlePagination={this.handlePagination}
              />
          </Col>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Broadcast Preference'
              color='106,196,96'
              negativeColor='171,255,159'
              gradientColor = 'gradient-green'
              data={metrics.broadcast.sort((a, b) => b.value - a.value)}
              dataType={TLM.TLM_BROADCAST}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              />
          </Col>
        </Row>
        <Row>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Network Preference'
              color='255,194,0'
              negativeColor='255,247,187'
              gradientColor = 'gradient-yellow'
              data={metrics.channel}
              dataType={TLM.TLM_CHANNEL}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              channelSelectedPage={this.state.channelSelectedPage}
              handlePagination={this.handlePagination}
              />
          </Col>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Genre Preference'
              color='161,109,196'
              negativeColor='227,195,253'
              gradientColor = 'gradient-purple'
              data={metrics.genre}
              dataType={TLM.TLM_GENRE}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              genreSelectedPage={this.state.genreSelectedPage}
              handlePagination={this.handlePagination}
              />
          </Col>
        </Row>
      </Container>
    )
  }
}